import { types } from 'mobx-state-tree';

import { partiallyUpdateModel } from '../definitions/Common';



const BaseVehicle = types
    .model('BaseVehicle', {
        year: types.maybe(types.number),
        make: types.maybe(types.string),
        model: types.maybe(types.string),
        code: types.maybe(types.string),
    })
    .actions(self => ({
        update(values) {
            partiallyUpdateModel(self, values);
        },
    }));

export default BaseVehicle;
